import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import "../styles/Layout.css";

function Layout() {
  return (
    <div className="layout">
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
